module.exports = __webpack_public_path__ + "static/media/pubdashboard.dd8b06de.png";